module.exports = __webpack_public_path__ + "assets/img/b3e4-il.svg";